<app-demo [context]="demoContext" [sources]="sources">
  <div actions>
    <p>
      Follow <a routerLink="/window">this link</a> to open the Entire Window
      scrollable demo.
    </p>
  </div>

  <div description>
    <p>
      The entire window might work as the viewport if
      <em>windowViewport</em> setting is set to true. Previous versions of the
      library (prior to 1.6.4) required the "overflow-anchor" css property to be
      disabled at the top level of the DOM tree (body or html tag). Today it is
      not necessary.
    </p>
  </div>
</app-demo>
